<script lang="ts">
import { defineComponent, PropType, computed } from 'vue'
import LayoutSearchResultContentsCards from '@/components/contents/LayoutSearchResultContentsCards.vue'
import { useUserStore } from '@/stores/user'

export default defineComponent({
  name: 'SectionForCategory',

  components: {
    LayoutSearchResultContentsCards,
  },

  props: {
    /**
     * 検索文言
     */
    searchWord: {
      type: String,
      default: '',
    },

    categorySearchResult: {
      type: Object as PropType<SearchResult>,
      required: true,
    },
  },

  setup(props) {
    // store
    const userStore = useUserStore()

    const renderSearchResult = computed(() => {
      // 未ログイン状態での表示件数
      const RENDER_NUMBER_FOR_GUEST = 3

      return userStore.context.isSignedIn
        ? props.categorySearchResult
        : {
          items: props.categorySearchResult.items.slice(0, RENDER_NUMBER_FOR_GUEST),
          totalCount: props.categorySearchResult.totalCount,
        }
    })

    return {
      // store
      userStore,

      // computed
      renderSearchResult,
    }
  },
})
</script>

<template>
  <section class="section">
    <LayoutSearchResultContentsCards
      :items="renderSearchResult.items"
      :search-word="searchWord" />
  </section>
</template>
